<template>
  <div>
    <el-dialog
      :title="this.value.isCreate ? '新增敏感词' : '修改敏感词'"
      center
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="700px"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="120px"
        size="mini"
      >
        <el-form-item label="敏感词">
          <el-input v-model="form.sensitiveWord"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("../../util");
export default {
  data() {
    return {
      visible: true,
      form: {
        sensitiveWord: "",
      },
      rules: {
        sensitiveWord: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },

  props: {
    value: Object,
  },

  created() {
    if (!this.value.isCreate) {
      this.form.sensitiveWord = this.value.oldData.sensitiveWord;
    }
  },

  methods: {
    /**
     * 提交表单
     */
    submit() {
      if (this.value.isCreate) {
        this.addSensitiveWord();
      } else {
        this.updateSensitiveWord();
      }
    },

    /**
     * 新增一个敏感词
     */
    addSensitiveWord() {
      this.$refs["form"].validate(async (valid) => {
        if (!valid) {
          this.$alert("请检查输入", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        }

        let sensitiveWord = this.form.sensitiveWord;

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/addSensitiveWord`,
            {
              sensitiveWord: sensitiveWord,
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "添加成功",
          type: "success",
        });

        // 关闭当前对话框
        this.visible = false;
      });
    },

    /**
     * 修改敏感词
     */
    updateSensitiveWord() {
      return;
    },

    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },   
  },
};
</script>